/*
 * Trypooh — Mystery-box bundle selector
 * Drives the product form's hidden [name=id] input from the selected bundle card.
 * The headline + sticky prices are swapped purely in CSS (:has() keyed to the
 * radio :checked state — see custom-product-info.liquid / custom-sticky-atc.liquid),
 * so this script does NOT write any price text. Progressive enhancement: if it
 * never runs, the form still submits the default variant id (server-rendered) at qty 1.
 */
(function () {
  function initBundle(root) {
    if (root.dataset.bundleInit === 'true') return;
    root.dataset.bundleInit = 'true';

    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    // Fallback: the hidden id input may live inside the nearest <product-info>.
    var idInput = form
      ? form.querySelector('[name=id]')
      : root.closest('product-info')
        ? root.closest('product-info').querySelector('[name=id]')
        : null;

    var radios = Array.prototype.slice.call(
      root.querySelectorAll('.trypooh-bundle__radio')
    );
    if (!radios.length) return;

    function select(radio) {
      if (!radio) return;

      // Sync the variant the product form will submit.
      if (idInput) {
        idInput.value = radio.value;
        idInput.removeAttribute('disabled');
      }

      // Reflect selection on the cards. (Price swap is CSS-only via :has().)
      radios.forEach(function (r) {
        var card = r.closest('.trypooh-bundle__card');
        if (card) card.classList.toggle('is-selected', r === radio);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) select(radio);
      });
    });

    // Establish the initial state from the server-rendered default (or first checked).
    var initial =
      root.querySelector('.trypooh-bundle__radio[data-bundle-default]') ||
      root.querySelector('.trypooh-bundle__radio:checked') ||
      radios[0];
    if (initial) {
      initial.checked = true;
      select(initial);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bundle-cards]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
